module.exports = "<navtab tabs=\"$ctrl.tabs\"></navtab>\n<div class=\"career-content\" ui-view></div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page/career/career.html
// module id = 1100
// module chunks = 3